import Vue from "vue";
import Vuetify from "vuetify/lib/framework";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    dark: false,
    themes: {
      light: {
        primary: "#c8a501",
        secondary: "#b0bec5",
        accent: "#40434E",
        error: "#b71c1c",
        btn: "#4287f5",
      },
    },
  },
});
